module.exports = __webpack_public_path__ + "static/media/tyra-beavers.b41f0f61.png";